import React from 'react'
import PropTypes from 'prop-types'

import { StyledSurvey } from './styles'

const SurveyMonkey = ({ appId = '', tokenId = '' }) => {
  if (appId !== 'prixinspirationlaval') return ''

  switch (tokenId) {
    case '1':
      return (
        <StyledSurvey>
          <div
            dangerouslySetInnerHTML={{
              __html: `<script>(function(t,e,s,n){var o,a,c;t.SMCX=t.SMCX||[],e.getElementById(n)||(o=e.getElementsByTagName(s),a=o[o.length-1],c=e.createElement(s),c.type="text/javascript",c.async=!0,c.id=n,c.src=["https:"===location.protocol?"https://":"http://","widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdwRtPYy9EhcIed0Jzivy0bfII_2BUf1AzKk4gig_2F_2FOfoW_2F.js"].join(""),a.parentNode.insertBefore(c,a))})(window,document,"script","smcx-sdk");</script>`,
            }}
          />
        </StyledSurvey>
      )
    case '2':
      return (
        <StyledSurvey>
          <div
            dangerouslySetInnerHTML={{
              __html: `<script>(function(t,e,s,n){var o,a,c;t.SMCX=t.SMCX||[],e.getElementById(n)||(o=e.getElementsByTagName(s),a=o[o.length-1],c=e.createElement(s),c.type="text/javascript",c.async=!0,c.id=n,c.src=["https:"===location.protocol?"https://":"http://","widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdwRtPYy9EhcIed0Jzivy0bfyFNtEqB4d8vbOWLbqpKLd.js"].join(""),a.parentNode.insertBefore(c,a))})(window,document,"script","smcx-sdk");</script>`,
            }}
          />
        </StyledSurvey>
      )
    case '3':
      return (
        <StyledSurvey>
          <div
            dangerouslySetInnerHTML={{
              __html: `<script>(function(t,e,s,n){var o,a,c;t.SMCX=t.SMCX||[],e.getElementById(n)||(o=e.getElementsByTagName(s),a=o[o.length-1],c=e.createElement(s),c.type="text/javascript",c.async=!0,c.id=n,c.src=["https:"===location.protocol?"https://":"http://","widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdwRtPYy9EhcIed0Jzivy0bfxPXIQ_2FHTvE94PpiuIy3y3.js"].join(""),a.parentNode.insertBefore(c,a))})(window,document,"script","smcx-sdk");</script>`,
            }}
          />
        </StyledSurvey>
      )
    default:
      return ''
  }
}

SurveyMonkey.propTypes = {
  appId: PropTypes.string,
  tokenId: PropTypes.string,
}

export default SurveyMonkey
